/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SecuredRouteImport } from './routes/_secured'
import { Route as SecuredIndexRouteImport } from './routes/_secured/index'
import { Route as PaymentCheckoutRouteImport } from './routes/payment_.checkout'
import { Route as SecuredProfileRouteImport } from './routes/_secured/profile'
import { Route as SecuredPaymentRouteImport } from './routes/_secured/payment'
import { Route as SecuredInfoRouteImport } from './routes/_secured/info'
import { Route as SecuredAdministrationRouteImport } from './routes/_secured/administration'
import { Route as SecuredSplatRouteImport } from './routes/_secured/$'
import { Route as SecuredProfileIndexRouteImport } from './routes/_secured/profile.index'
import { Route as SecuredAdministrationIndexRouteImport } from './routes/_secured/administration.index'
import { Route as SecuredProfileSecurityRouteImport } from './routes/_secured/profile.security'
import { Route as SecuredProfileApiCredentialsRouteImport } from './routes/_secured/profile.api-credentials'
import { Route as SecuredPaymentSuccessRouteImport } from './routes/_secured/payment_.success'
import { Route as SecuredAdministrationUsersRouteImport } from './routes/_secured/administration.users'
import { Route as SecuredAdministrationUserGroupsRouteImport } from './routes/_secured/administration.user-groups'
import { Route as SecuredAdministrationRegisterCmpRouteImport } from './routes/_secured/administration.register-cmp'
import { Route as SecuredAdministrationMetaSitesRouteImport } from './routes/_secured/administration.meta-sites'
import { Route as SecuredAdministrationAppsRouteImport } from './routes/_secured/administration.apps'
import { Route as SecuredAdministrationAccountRouteImport } from './routes/_secured/administration.account'
import { Route as SecuredAdministrationUsersIndexRouteImport } from './routes/_secured/administration.users.index'
import { Route as SecuredAdministrationUserGroupsIndexRouteImport } from './routes/_secured/administration.user-groups.index'
import { Route as SecuredAdministrationMetaSitesIndexRouteImport } from './routes/_secured/administration.meta-sites.index'
import { Route as SecuredAdministrationAppsIndexRouteImport } from './routes/_secured/administration.apps.index'
import { Route as SecuredAdministrationAccountIndexRouteImport } from './routes/_secured/administration.account.index'
import { Route as SecuredInfoNoSubscriptionModuleNameRouteImport } from './routes/_secured/info.no-subscription.$moduleName'
import { Route as SecuredAdministrationUsersUserIdRouteImport } from './routes/_secured/administration.users.$userId'
import { Route as SecuredAdministrationUserGroupsGroupIdRouteImport } from './routes/_secured/administration.user-groups.$groupId'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId'
import { Route as SecuredAdministrationAppsAppIdRouteImport } from './routes/_secured/administration.apps.$appId'
import { Route as SecuredAdministrationAccountSubscriptionRouteImport } from './routes/_secured/administration.account.subscription'
import { Route as SecuredAdministrationAccountDomainsRouteImport } from './routes/_secured/administration.account.domains'
import { Route as SecuredAdministrationAccountBillingRouteImport } from './routes/_secured/administration.account.billing'
import { Route as SecuredAdministrationAccountAuditLogRouteImport } from './routes/_secured/administration.account.audit-log'
import { Route as SecuredAdministrationAccountAppRouteImport } from './routes/_secured/administration.account.app'
import { Route as SecuredAdministrationAccountAccountSettingsRouteImport } from './routes/_secured/administration.account.account-settings'
import { Route as SecuredAdministrationUserGroupsGroupIdIndexRouteImport } from './routes/_secured/administration.user-groups.$groupId.index'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdIndexRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId.index'
import { Route as SecuredAdministrationAppsAppIdIndexRouteImport } from './routes/_secured/administration.apps.$appId.index'
import { Route as SecuredAdministrationAccountBillingIndexRouteImport } from './routes/_secured/administration.account.billing.index'
import { Route as SecuredAdministrationAccountAuditLogIndexRouteImport } from './routes/_secured/administration.account.audit-log.index'
import { Route as SecuredAdministrationAccountAppIndexRouteImport } from './routes/_secured/administration.account.app.index'
import { Route as SecuredProfileApiCredentialsMCreateRouteImport } from './routes/_secured/profile.api-credentials.m.create'
import { Route as SecuredAdministrationUserGroupsGroupIdPermissionsRouteImport } from './routes/_secured/administration.user-groups.$groupId.permissions'
import { Route as SecuredAdministrationUserGroupsGroupIdMembersRouteImport } from './routes/_secured/administration.user-groups.$groupId.members'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId.settings'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId.permissions'
import { Route as SecuredAdministrationAppsAppIdReportsRouteImport } from './routes/_secured/administration.apps.$appId.reports'
import { Route as SecuredAdministrationAppsAppIdPrivacyRouteImport } from './routes/_secured/administration.apps.$appId.privacy'
import { Route as SecuredAdministrationAppsAppIdPermissionsRouteImport } from './routes/_secured/administration.apps.$appId.permissions'
import { Route as SecuredAdministrationAppsAppIdInstallationRouteImport } from './routes/_secured/administration.apps.$appId.installation'
import { Route as SecuredAdministrationAppsAppIdDataCollectionRouteImport } from './routes/_secured/administration.apps.$appId.data-collection'
import { Route as SecuredAdministrationAccountAppPrivacyRouteImport } from './routes/_secured/administration.account.app.privacy'
import { Route as SecuredAdministrationAccountAppDataCollectionRouteImport } from './routes/_secured/administration.account.app.data-collection'
import { Route as SecuredAdministrationUserGroupsGroupIdPermissionsIndexRouteImport } from './routes/_secured/administration.user-groups.$groupId.permissions.index'
import { Route as SecuredAdministrationUserGroupsGroupIdMembersIndexRouteImport } from './routes/_secured/administration.user-groups.$groupId.members.index'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId.settings.index'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId.permissions.index'
import { Route as SecuredAdministrationAppsAppIdPermissionsIndexRouteImport } from './routes/_secured/administration.apps.$appId.permissions.index'
import { Route as SecuredAdministrationAppsAppIdInstallationIndexRouteImport } from './routes/_secured/administration.apps.$appId.installation.index'
import { Route as SecuredAdministrationAppsAppIdInstallationSitesRouteImport } from './routes/_secured/administration.apps.$appId.installation.sites'
import { Route as SecuredAdministrationAppsAppIdInstallationMobileAppsRouteImport } from './routes/_secured/administration.apps.$appId.installation.mobile-apps'
import { Route as SecuredAdministrationAccountDomainsMAddDomainRouteImport } from './routes/_secured/administration.account.domains.m.add-domain'
import { Route as SecuredAdministrationAccountBillingPageLimitRouteImport } from './routes/_secured/administration.account.billing.$page.$limit'
import { Route as SecuredAdministrationAccountAuditLogPageLimitRouteImport } from './routes/_secured/administration.account.audit-log.$page.$limit'
import { Route as SecuredAdministrationAccountAccountSettingsOEditLogoRouteImport } from './routes/_secured/administration.account.account-settings.o.edit-logo'
import { Route as SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRouteImport } from './routes/_secured/administration.user-groups.$groupId.permissions.$page.$limit'
import { Route as SecuredAdministrationUserGroupsGroupIdMembersPageLimitRouteImport } from './routes/_secured/administration.user-groups.$groupId.members.$page.$limit'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId.settings.$page.$limit'
import { Route as SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteImport } from './routes/_secured/administration.apps.$appId.sdg.$sdgPage.$sdgLimit'
import { Route as SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRouteImport } from './routes/_secured/administration.apps.$appId.data-collection.m.edit-tracking-domains'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId.permissions.users.$page.$limit'
import { Route as SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRouteImport } from './routes/_secured/administration.meta-sites.$metaSiteId.permissions.user-groups.$page.$limit'
import { Route as SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRouteImport } from './routes/_secured/administration.apps.$appId.permissions.users.$page.$limit'
import { Route as SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRouteImport } from './routes/_secured/administration.apps.$appId.permissions.user-groups.$page.$limit'
import { Route as SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRouteImport } from './routes/_secured/administration.apps.$appId.sdg.$sdgPage.$sdgLimit.o.details.$reportId.$page.$limit'

const SecuredRoute = SecuredRouteImport.update({
  id: '/_secured',
  getParentRoute: () => rootRouteImport,
} as any)
const SecuredIndexRoute = SecuredIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecuredRoute,
} as any)
const PaymentCheckoutRoute = PaymentCheckoutRouteImport.update({
  id: '/payment_/checkout',
  path: '/payment/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const SecuredProfileRoute = SecuredProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SecuredRoute,
} as any)
const SecuredPaymentRoute = SecuredPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => SecuredRoute,
} as any)
const SecuredInfoRoute = SecuredInfoRouteImport.update({
  id: '/info',
  path: '/info',
  getParentRoute: () => SecuredRoute,
} as any)
const SecuredAdministrationRoute = SecuredAdministrationRouteImport.update({
  id: '/administration',
  path: '/administration',
  getParentRoute: () => SecuredRoute,
} as any)
const SecuredSplatRoute = SecuredSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SecuredRoute,
} as any)
const SecuredProfileIndexRoute = SecuredProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecuredProfileRoute,
} as any)
const SecuredAdministrationIndexRoute =
  SecuredAdministrationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationRoute,
  } as any)
const SecuredProfileSecurityRoute = SecuredProfileSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => SecuredProfileRoute,
} as any)
const SecuredProfileApiCredentialsRoute =
  SecuredProfileApiCredentialsRouteImport.update({
    id: '/api-credentials',
    path: '/api-credentials',
    getParentRoute: () => SecuredProfileRoute,
  } as any)
const SecuredPaymentSuccessRoute = SecuredPaymentSuccessRouteImport.update({
  id: '/payment_/success',
  path: '/payment/success',
  getParentRoute: () => SecuredRoute,
} as any)
const SecuredAdministrationUsersRoute =
  SecuredAdministrationUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => SecuredAdministrationRoute,
  } as any)
const SecuredAdministrationUserGroupsRoute =
  SecuredAdministrationUserGroupsRouteImport.update({
    id: '/user-groups',
    path: '/user-groups',
    getParentRoute: () => SecuredAdministrationRoute,
  } as any)
const SecuredAdministrationRegisterCmpRoute =
  SecuredAdministrationRegisterCmpRouteImport.update({
    id: '/register-cmp',
    path: '/register-cmp',
    getParentRoute: () => SecuredAdministrationRoute,
  } as any)
const SecuredAdministrationMetaSitesRoute =
  SecuredAdministrationMetaSitesRouteImport.update({
    id: '/meta-sites',
    path: '/meta-sites',
    getParentRoute: () => SecuredAdministrationRoute,
  } as any)
const SecuredAdministrationAppsRoute =
  SecuredAdministrationAppsRouteImport.update({
    id: '/apps',
    path: '/apps',
    getParentRoute: () => SecuredAdministrationRoute,
  } as any)
const SecuredAdministrationAccountRoute =
  SecuredAdministrationAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => SecuredAdministrationRoute,
  } as any)
const SecuredAdministrationUsersIndexRoute =
  SecuredAdministrationUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationUsersRoute,
  } as any)
const SecuredAdministrationUserGroupsIndexRoute =
  SecuredAdministrationUserGroupsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationUserGroupsRoute,
  } as any)
const SecuredAdministrationMetaSitesIndexRoute =
  SecuredAdministrationMetaSitesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationMetaSitesRoute,
  } as any)
const SecuredAdministrationAppsIndexRoute =
  SecuredAdministrationAppsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationAppsRoute,
  } as any)
const SecuredAdministrationAccountIndexRoute =
  SecuredAdministrationAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationAccountRoute,
  } as any)
const SecuredInfoNoSubscriptionModuleNameRoute =
  SecuredInfoNoSubscriptionModuleNameRouteImport.update({
    id: '/no-subscription/$moduleName',
    path: '/no-subscription/$moduleName',
    getParentRoute: () => SecuredInfoRoute,
  } as any)
const SecuredAdministrationUsersUserIdRoute =
  SecuredAdministrationUsersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => SecuredAdministrationUsersRoute,
  } as any)
const SecuredAdministrationUserGroupsGroupIdRoute =
  SecuredAdministrationUserGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => SecuredAdministrationUserGroupsRoute,
  } as any)
const SecuredAdministrationMetaSitesMetaSiteIdRoute =
  SecuredAdministrationMetaSitesMetaSiteIdRouteImport.update({
    id: '/$metaSiteId',
    path: '/$metaSiteId',
    getParentRoute: () => SecuredAdministrationMetaSitesRoute,
  } as any)
const SecuredAdministrationAppsAppIdRoute =
  SecuredAdministrationAppsAppIdRouteImport.update({
    id: '/$appId',
    path: '/$appId',
    getParentRoute: () => SecuredAdministrationAppsRoute,
  } as any)
const SecuredAdministrationAccountSubscriptionRoute =
  SecuredAdministrationAccountSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => SecuredAdministrationAccountRoute,
  } as any)
const SecuredAdministrationAccountDomainsRoute =
  SecuredAdministrationAccountDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => SecuredAdministrationAccountRoute,
  } as any)
const SecuredAdministrationAccountBillingRoute =
  SecuredAdministrationAccountBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => SecuredAdministrationAccountRoute,
  } as any)
const SecuredAdministrationAccountAuditLogRoute =
  SecuredAdministrationAccountAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => SecuredAdministrationAccountRoute,
  } as any)
const SecuredAdministrationAccountAppRoute =
  SecuredAdministrationAccountAppRouteImport.update({
    id: '/app',
    path: '/app',
    getParentRoute: () => SecuredAdministrationAccountRoute,
  } as any)
const SecuredAdministrationAccountAccountSettingsRoute =
  SecuredAdministrationAccountAccountSettingsRouteImport.update({
    id: '/account-settings',
    path: '/account-settings',
    getParentRoute: () => SecuredAdministrationAccountRoute,
  } as any)
const SecuredAdministrationUserGroupsGroupIdIndexRoute =
  SecuredAdministrationUserGroupsGroupIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationUserGroupsGroupIdRoute,
  } as any)
const SecuredAdministrationMetaSitesMetaSiteIdIndexRoute =
  SecuredAdministrationMetaSitesMetaSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationMetaSitesMetaSiteIdRoute,
  } as any)
const SecuredAdministrationAppsAppIdIndexRoute =
  SecuredAdministrationAppsAppIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationAppsAppIdRoute,
  } as any)
const SecuredAdministrationAccountBillingIndexRoute =
  SecuredAdministrationAccountBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationAccountBillingRoute,
  } as any)
const SecuredAdministrationAccountAuditLogIndexRoute =
  SecuredAdministrationAccountAuditLogIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationAccountAuditLogRoute,
  } as any)
const SecuredAdministrationAccountAppIndexRoute =
  SecuredAdministrationAccountAppIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationAccountAppRoute,
  } as any)
const SecuredProfileApiCredentialsMCreateRoute =
  SecuredProfileApiCredentialsMCreateRouteImport.update({
    id: '/m/create',
    path: '/m/create',
    getParentRoute: () => SecuredProfileApiCredentialsRoute,
  } as any)
const SecuredAdministrationUserGroupsGroupIdPermissionsRoute =
  SecuredAdministrationUserGroupsGroupIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => SecuredAdministrationUserGroupsGroupIdRoute,
  } as any)
const SecuredAdministrationUserGroupsGroupIdMembersRoute =
  SecuredAdministrationUserGroupsGroupIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => SecuredAdministrationUserGroupsGroupIdRoute,
  } as any)
const SecuredAdministrationMetaSitesMetaSiteIdSettingsRoute =
  SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => SecuredAdministrationMetaSitesMetaSiteIdRoute,
  } as any)
const SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute =
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => SecuredAdministrationMetaSitesMetaSiteIdRoute,
  } as any)
const SecuredAdministrationAppsAppIdReportsRoute =
  SecuredAdministrationAppsAppIdReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => SecuredAdministrationAppsAppIdRoute,
  } as any)
const SecuredAdministrationAppsAppIdPrivacyRoute =
  SecuredAdministrationAppsAppIdPrivacyRouteImport.update({
    id: '/privacy',
    path: '/privacy',
    getParentRoute: () => SecuredAdministrationAppsAppIdRoute,
  } as any)
const SecuredAdministrationAppsAppIdPermissionsRoute =
  SecuredAdministrationAppsAppIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => SecuredAdministrationAppsAppIdRoute,
  } as any)
const SecuredAdministrationAppsAppIdInstallationRoute =
  SecuredAdministrationAppsAppIdInstallationRouteImport.update({
    id: '/installation',
    path: '/installation',
    getParentRoute: () => SecuredAdministrationAppsAppIdRoute,
  } as any)
const SecuredAdministrationAppsAppIdDataCollectionRoute =
  SecuredAdministrationAppsAppIdDataCollectionRouteImport.update({
    id: '/data-collection',
    path: '/data-collection',
    getParentRoute: () => SecuredAdministrationAppsAppIdRoute,
  } as any)
const SecuredAdministrationAccountAppPrivacyRoute =
  SecuredAdministrationAccountAppPrivacyRouteImport.update({
    id: '/privacy',
    path: '/privacy',
    getParentRoute: () => SecuredAdministrationAccountAppRoute,
  } as any)
const SecuredAdministrationAccountAppDataCollectionRoute =
  SecuredAdministrationAccountAppDataCollectionRouteImport.update({
    id: '/data-collection',
    path: '/data-collection',
    getParentRoute: () => SecuredAdministrationAccountAppRoute,
  } as any)
const SecuredAdministrationUserGroupsGroupIdPermissionsIndexRoute =
  SecuredAdministrationUserGroupsGroupIdPermissionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      SecuredAdministrationUserGroupsGroupIdPermissionsRoute,
  } as any)
const SecuredAdministrationUserGroupsGroupIdMembersIndexRoute =
  SecuredAdministrationUserGroupsGroupIdMembersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationUserGroupsGroupIdMembersRoute,
  } as any)
const SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRoute =
  SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationMetaSitesMetaSiteIdSettingsRoute,
  } as any)
const SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRoute =
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute,
  } as any)
const SecuredAdministrationAppsAppIdPermissionsIndexRoute =
  SecuredAdministrationAppsAppIdPermissionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationAppsAppIdPermissionsRoute,
  } as any)
const SecuredAdministrationAppsAppIdInstallationIndexRoute =
  SecuredAdministrationAppsAppIdInstallationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SecuredAdministrationAppsAppIdInstallationRoute,
  } as any)
const SecuredAdministrationAppsAppIdInstallationSitesRoute =
  SecuredAdministrationAppsAppIdInstallationSitesRouteImport.update({
    id: '/sites',
    path: '/sites',
    getParentRoute: () => SecuredAdministrationAppsAppIdInstallationRoute,
  } as any)
const SecuredAdministrationAppsAppIdInstallationMobileAppsRoute =
  SecuredAdministrationAppsAppIdInstallationMobileAppsRouteImport.update({
    id: '/mobile-apps',
    path: '/mobile-apps',
    getParentRoute: () => SecuredAdministrationAppsAppIdInstallationRoute,
  } as any)
const SecuredAdministrationAccountDomainsMAddDomainRoute =
  SecuredAdministrationAccountDomainsMAddDomainRouteImport.update({
    id: '/m/add-domain',
    path: '/m/add-domain',
    getParentRoute: () => SecuredAdministrationAccountDomainsRoute,
  } as any)
const SecuredAdministrationAccountBillingPageLimitRoute =
  SecuredAdministrationAccountBillingPageLimitRouteImport.update({
    id: '/$page/$limit',
    path: '/$page/$limit',
    getParentRoute: () => SecuredAdministrationAccountBillingRoute,
  } as any)
const SecuredAdministrationAccountAuditLogPageLimitRoute =
  SecuredAdministrationAccountAuditLogPageLimitRouteImport.update({
    id: '/$page/$limit',
    path: '/$page/$limit',
    getParentRoute: () => SecuredAdministrationAccountAuditLogRoute,
  } as any)
const SecuredAdministrationAccountAccountSettingsOEditLogoRoute =
  SecuredAdministrationAccountAccountSettingsOEditLogoRouteImport.update({
    id: '/o/edit-logo',
    path: '/o/edit-logo',
    getParentRoute: () => SecuredAdministrationAccountAccountSettingsRoute,
  } as any)
const SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRoute =
  SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRouteImport.update({
    id: '/$page/$limit',
    path: '/$page/$limit',
    getParentRoute: () =>
      SecuredAdministrationUserGroupsGroupIdPermissionsRoute,
  } as any)
const SecuredAdministrationUserGroupsGroupIdMembersPageLimitRoute =
  SecuredAdministrationUserGroupsGroupIdMembersPageLimitRouteImport.update({
    id: '/$page/$limit',
    path: '/$page/$limit',
    getParentRoute: () => SecuredAdministrationUserGroupsGroupIdMembersRoute,
  } as any)
const SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRoute =
  SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRouteImport.update({
    id: '/$page/$limit',
    path: '/$page/$limit',
    getParentRoute: () => SecuredAdministrationMetaSitesMetaSiteIdSettingsRoute,
  } as any)
const SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRoute =
  SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteImport.update({
    id: '/sdg/$sdgPage/$sdgLimit',
    path: '/sdg/$sdgPage/$sdgLimit',
    getParentRoute: () => SecuredAdministrationAppsAppIdRoute,
  } as any)
const SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRoute =
  SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRouteImport.update(
    {
      id: '/m/edit-tracking-domains',
      path: '/m/edit-tracking-domains',
      getParentRoute: () => SecuredAdministrationAppsAppIdDataCollectionRoute,
    } as any,
  )
const SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRoute =
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRouteImport.update(
    {
      id: '/users/$page/$limit',
      path: '/users/$page/$limit',
      getParentRoute: () =>
        SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute,
    } as any,
  )
const SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRoute =
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRouteImport.update(
    {
      id: '/user-groups/$page/$limit',
      path: '/user-groups/$page/$limit',
      getParentRoute: () =>
        SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute,
    } as any,
  )
const SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRoute =
  SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRouteImport.update({
    id: '/users/$page/$limit',
    path: '/users/$page/$limit',
    getParentRoute: () => SecuredAdministrationAppsAppIdPermissionsRoute,
  } as any)
const SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRoute =
  SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRouteImport.update(
    {
      id: '/user-groups/$page/$limit',
      path: '/user-groups/$page/$limit',
      getParentRoute: () => SecuredAdministrationAppsAppIdPermissionsRoute,
    } as any,
  )
const SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRoute =
  SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRouteImport.update(
    {
      id: '/o/details/$reportId/$page/$limit',
      path: '/o/details/$reportId/$page/$limit',
      getParentRoute: () =>
        SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof SecuredIndexRoute
  '/$': typeof SecuredSplatRoute
  '/administration': typeof SecuredAdministrationRouteWithChildren
  '/info': typeof SecuredInfoRouteWithChildren
  '/payment': typeof SecuredPaymentRoute
  '/profile': typeof SecuredProfileRouteWithChildren
  '/payment/checkout': typeof PaymentCheckoutRoute
  '/administration/account': typeof SecuredAdministrationAccountRouteWithChildren
  '/administration/apps': typeof SecuredAdministrationAppsRouteWithChildren
  '/administration/meta-sites': typeof SecuredAdministrationMetaSitesRouteWithChildren
  '/administration/register-cmp': typeof SecuredAdministrationRegisterCmpRoute
  '/administration/user-groups': typeof SecuredAdministrationUserGroupsRouteWithChildren
  '/administration/users': typeof SecuredAdministrationUsersRouteWithChildren
  '/payment/success': typeof SecuredPaymentSuccessRoute
  '/profile/api-credentials': typeof SecuredProfileApiCredentialsRouteWithChildren
  '/profile/security': typeof SecuredProfileSecurityRoute
  '/administration/': typeof SecuredAdministrationIndexRoute
  '/profile/': typeof SecuredProfileIndexRoute
  '/administration/account/account-settings': typeof SecuredAdministrationAccountAccountSettingsRouteWithChildren
  '/administration/account/app': typeof SecuredAdministrationAccountAppRouteWithChildren
  '/administration/account/audit-log': typeof SecuredAdministrationAccountAuditLogRouteWithChildren
  '/administration/account/billing': typeof SecuredAdministrationAccountBillingRouteWithChildren
  '/administration/account/domains': typeof SecuredAdministrationAccountDomainsRouteWithChildren
  '/administration/account/subscription': typeof SecuredAdministrationAccountSubscriptionRoute
  '/administration/apps/$appId': typeof SecuredAdministrationAppsAppIdRouteWithChildren
  '/administration/meta-sites/$metaSiteId': typeof SecuredAdministrationMetaSitesMetaSiteIdRouteWithChildren
  '/administration/user-groups/$groupId': typeof SecuredAdministrationUserGroupsGroupIdRouteWithChildren
  '/administration/users/$userId': typeof SecuredAdministrationUsersUserIdRoute
  '/info/no-subscription/$moduleName': typeof SecuredInfoNoSubscriptionModuleNameRoute
  '/administration/account/': typeof SecuredAdministrationAccountIndexRoute
  '/administration/apps/': typeof SecuredAdministrationAppsIndexRoute
  '/administration/meta-sites/': typeof SecuredAdministrationMetaSitesIndexRoute
  '/administration/user-groups/': typeof SecuredAdministrationUserGroupsIndexRoute
  '/administration/users/': typeof SecuredAdministrationUsersIndexRoute
  '/administration/account/app/data-collection': typeof SecuredAdministrationAccountAppDataCollectionRoute
  '/administration/account/app/privacy': typeof SecuredAdministrationAccountAppPrivacyRoute
  '/administration/apps/$appId/data-collection': typeof SecuredAdministrationAppsAppIdDataCollectionRouteWithChildren
  '/administration/apps/$appId/installation': typeof SecuredAdministrationAppsAppIdInstallationRouteWithChildren
  '/administration/apps/$appId/permissions': typeof SecuredAdministrationAppsAppIdPermissionsRouteWithChildren
  '/administration/apps/$appId/privacy': typeof SecuredAdministrationAppsAppIdPrivacyRoute
  '/administration/apps/$appId/reports': typeof SecuredAdministrationAppsAppIdReportsRoute
  '/administration/meta-sites/$metaSiteId/permissions': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteWithChildren
  '/administration/meta-sites/$metaSiteId/settings': typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteWithChildren
  '/administration/user-groups/$groupId/members': typeof SecuredAdministrationUserGroupsGroupIdMembersRouteWithChildren
  '/administration/user-groups/$groupId/permissions': typeof SecuredAdministrationUserGroupsGroupIdPermissionsRouteWithChildren
  '/profile/api-credentials/m/create': typeof SecuredProfileApiCredentialsMCreateRoute
  '/administration/account/app/': typeof SecuredAdministrationAccountAppIndexRoute
  '/administration/account/audit-log/': typeof SecuredAdministrationAccountAuditLogIndexRoute
  '/administration/account/billing/': typeof SecuredAdministrationAccountBillingIndexRoute
  '/administration/apps/$appId/': typeof SecuredAdministrationAppsAppIdIndexRoute
  '/administration/meta-sites/$metaSiteId/': typeof SecuredAdministrationMetaSitesMetaSiteIdIndexRoute
  '/administration/user-groups/$groupId/': typeof SecuredAdministrationUserGroupsGroupIdIndexRoute
  '/administration/account/account-settings/o/edit-logo': typeof SecuredAdministrationAccountAccountSettingsOEditLogoRoute
  '/administration/account/audit-log/$page/$limit': typeof SecuredAdministrationAccountAuditLogPageLimitRoute
  '/administration/account/billing/$page/$limit': typeof SecuredAdministrationAccountBillingPageLimitRoute
  '/administration/account/domains/m/add-domain': typeof SecuredAdministrationAccountDomainsMAddDomainRoute
  '/administration/apps/$appId/installation/mobile-apps': typeof SecuredAdministrationAppsAppIdInstallationMobileAppsRoute
  '/administration/apps/$appId/installation/sites': typeof SecuredAdministrationAppsAppIdInstallationSitesRoute
  '/administration/apps/$appId/installation/': typeof SecuredAdministrationAppsAppIdInstallationIndexRoute
  '/administration/apps/$appId/permissions/': typeof SecuredAdministrationAppsAppIdPermissionsIndexRoute
  '/administration/meta-sites/$metaSiteId/permissions/': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRoute
  '/administration/meta-sites/$metaSiteId/settings/': typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRoute
  '/administration/user-groups/$groupId/members/': typeof SecuredAdministrationUserGroupsGroupIdMembersIndexRoute
  '/administration/user-groups/$groupId/permissions/': typeof SecuredAdministrationUserGroupsGroupIdPermissionsIndexRoute
  '/administration/apps/$appId/data-collection/m/edit-tracking-domains': typeof SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRoute
  '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit': typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteWithChildren
  '/administration/meta-sites/$metaSiteId/settings/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRoute
  '/administration/user-groups/$groupId/members/$page/$limit': typeof SecuredAdministrationUserGroupsGroupIdMembersPageLimitRoute
  '/administration/user-groups/$groupId/permissions/$page/$limit': typeof SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRoute
  '/administration/apps/$appId/permissions/user-groups/$page/$limit': typeof SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRoute
  '/administration/apps/$appId/permissions/users/$page/$limit': typeof SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRoute
  '/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRoute
  '/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRoute
  '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit': typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRoute
}
export interface FileRoutesByTo {
  '/$': typeof SecuredSplatRoute
  '/info': typeof SecuredInfoRouteWithChildren
  '/payment': typeof SecuredPaymentRoute
  '/payment/checkout': typeof PaymentCheckoutRoute
  '/': typeof SecuredIndexRoute
  '/administration/register-cmp': typeof SecuredAdministrationRegisterCmpRoute
  '/payment/success': typeof SecuredPaymentSuccessRoute
  '/profile/api-credentials': typeof SecuredProfileApiCredentialsRouteWithChildren
  '/profile/security': typeof SecuredProfileSecurityRoute
  '/administration': typeof SecuredAdministrationIndexRoute
  '/profile': typeof SecuredProfileIndexRoute
  '/administration/account/account-settings': typeof SecuredAdministrationAccountAccountSettingsRouteWithChildren
  '/administration/account/domains': typeof SecuredAdministrationAccountDomainsRouteWithChildren
  '/administration/account/subscription': typeof SecuredAdministrationAccountSubscriptionRoute
  '/administration/users/$userId': typeof SecuredAdministrationUsersUserIdRoute
  '/info/no-subscription/$moduleName': typeof SecuredInfoNoSubscriptionModuleNameRoute
  '/administration/account': typeof SecuredAdministrationAccountIndexRoute
  '/administration/apps': typeof SecuredAdministrationAppsIndexRoute
  '/administration/meta-sites': typeof SecuredAdministrationMetaSitesIndexRoute
  '/administration/user-groups': typeof SecuredAdministrationUserGroupsIndexRoute
  '/administration/users': typeof SecuredAdministrationUsersIndexRoute
  '/administration/account/app/data-collection': typeof SecuredAdministrationAccountAppDataCollectionRoute
  '/administration/account/app/privacy': typeof SecuredAdministrationAccountAppPrivacyRoute
  '/administration/apps/$appId/data-collection': typeof SecuredAdministrationAppsAppIdDataCollectionRouteWithChildren
  '/administration/apps/$appId/privacy': typeof SecuredAdministrationAppsAppIdPrivacyRoute
  '/administration/apps/$appId/reports': typeof SecuredAdministrationAppsAppIdReportsRoute
  '/profile/api-credentials/m/create': typeof SecuredProfileApiCredentialsMCreateRoute
  '/administration/account/app': typeof SecuredAdministrationAccountAppIndexRoute
  '/administration/account/audit-log': typeof SecuredAdministrationAccountAuditLogIndexRoute
  '/administration/account/billing': typeof SecuredAdministrationAccountBillingIndexRoute
  '/administration/apps/$appId': typeof SecuredAdministrationAppsAppIdIndexRoute
  '/administration/meta-sites/$metaSiteId': typeof SecuredAdministrationMetaSitesMetaSiteIdIndexRoute
  '/administration/user-groups/$groupId': typeof SecuredAdministrationUserGroupsGroupIdIndexRoute
  '/administration/account/account-settings/o/edit-logo': typeof SecuredAdministrationAccountAccountSettingsOEditLogoRoute
  '/administration/account/audit-log/$page/$limit': typeof SecuredAdministrationAccountAuditLogPageLimitRoute
  '/administration/account/billing/$page/$limit': typeof SecuredAdministrationAccountBillingPageLimitRoute
  '/administration/account/domains/m/add-domain': typeof SecuredAdministrationAccountDomainsMAddDomainRoute
  '/administration/apps/$appId/installation/mobile-apps': typeof SecuredAdministrationAppsAppIdInstallationMobileAppsRoute
  '/administration/apps/$appId/installation/sites': typeof SecuredAdministrationAppsAppIdInstallationSitesRoute
  '/administration/apps/$appId/installation': typeof SecuredAdministrationAppsAppIdInstallationIndexRoute
  '/administration/apps/$appId/permissions': typeof SecuredAdministrationAppsAppIdPermissionsIndexRoute
  '/administration/meta-sites/$metaSiteId/permissions': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRoute
  '/administration/meta-sites/$metaSiteId/settings': typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRoute
  '/administration/user-groups/$groupId/members': typeof SecuredAdministrationUserGroupsGroupIdMembersIndexRoute
  '/administration/user-groups/$groupId/permissions': typeof SecuredAdministrationUserGroupsGroupIdPermissionsIndexRoute
  '/administration/apps/$appId/data-collection/m/edit-tracking-domains': typeof SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRoute
  '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit': typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteWithChildren
  '/administration/meta-sites/$metaSiteId/settings/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRoute
  '/administration/user-groups/$groupId/members/$page/$limit': typeof SecuredAdministrationUserGroupsGroupIdMembersPageLimitRoute
  '/administration/user-groups/$groupId/permissions/$page/$limit': typeof SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRoute
  '/administration/apps/$appId/permissions/user-groups/$page/$limit': typeof SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRoute
  '/administration/apps/$appId/permissions/users/$page/$limit': typeof SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRoute
  '/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRoute
  '/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRoute
  '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit': typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_secured': typeof SecuredRouteWithChildren
  '/_secured/$': typeof SecuredSplatRoute
  '/_secured/administration': typeof SecuredAdministrationRouteWithChildren
  '/_secured/info': typeof SecuredInfoRouteWithChildren
  '/_secured/payment': typeof SecuredPaymentRoute
  '/_secured/profile': typeof SecuredProfileRouteWithChildren
  '/payment_/checkout': typeof PaymentCheckoutRoute
  '/_secured/': typeof SecuredIndexRoute
  '/_secured/administration/account': typeof SecuredAdministrationAccountRouteWithChildren
  '/_secured/administration/apps': typeof SecuredAdministrationAppsRouteWithChildren
  '/_secured/administration/meta-sites': typeof SecuredAdministrationMetaSitesRouteWithChildren
  '/_secured/administration/register-cmp': typeof SecuredAdministrationRegisterCmpRoute
  '/_secured/administration/user-groups': typeof SecuredAdministrationUserGroupsRouteWithChildren
  '/_secured/administration/users': typeof SecuredAdministrationUsersRouteWithChildren
  '/_secured/payment_/success': typeof SecuredPaymentSuccessRoute
  '/_secured/profile/api-credentials': typeof SecuredProfileApiCredentialsRouteWithChildren
  '/_secured/profile/security': typeof SecuredProfileSecurityRoute
  '/_secured/administration/': typeof SecuredAdministrationIndexRoute
  '/_secured/profile/': typeof SecuredProfileIndexRoute
  '/_secured/administration/account/account-settings': typeof SecuredAdministrationAccountAccountSettingsRouteWithChildren
  '/_secured/administration/account/app': typeof SecuredAdministrationAccountAppRouteWithChildren
  '/_secured/administration/account/audit-log': typeof SecuredAdministrationAccountAuditLogRouteWithChildren
  '/_secured/administration/account/billing': typeof SecuredAdministrationAccountBillingRouteWithChildren
  '/_secured/administration/account/domains': typeof SecuredAdministrationAccountDomainsRouteWithChildren
  '/_secured/administration/account/subscription': typeof SecuredAdministrationAccountSubscriptionRoute
  '/_secured/administration/apps/$appId': typeof SecuredAdministrationAppsAppIdRouteWithChildren
  '/_secured/administration/meta-sites/$metaSiteId': typeof SecuredAdministrationMetaSitesMetaSiteIdRouteWithChildren
  '/_secured/administration/user-groups/$groupId': typeof SecuredAdministrationUserGroupsGroupIdRouteWithChildren
  '/_secured/administration/users/$userId': typeof SecuredAdministrationUsersUserIdRoute
  '/_secured/info/no-subscription/$moduleName': typeof SecuredInfoNoSubscriptionModuleNameRoute
  '/_secured/administration/account/': typeof SecuredAdministrationAccountIndexRoute
  '/_secured/administration/apps/': typeof SecuredAdministrationAppsIndexRoute
  '/_secured/administration/meta-sites/': typeof SecuredAdministrationMetaSitesIndexRoute
  '/_secured/administration/user-groups/': typeof SecuredAdministrationUserGroupsIndexRoute
  '/_secured/administration/users/': typeof SecuredAdministrationUsersIndexRoute
  '/_secured/administration/account/app/data-collection': typeof SecuredAdministrationAccountAppDataCollectionRoute
  '/_secured/administration/account/app/privacy': typeof SecuredAdministrationAccountAppPrivacyRoute
  '/_secured/administration/apps/$appId/data-collection': typeof SecuredAdministrationAppsAppIdDataCollectionRouteWithChildren
  '/_secured/administration/apps/$appId/installation': typeof SecuredAdministrationAppsAppIdInstallationRouteWithChildren
  '/_secured/administration/apps/$appId/permissions': typeof SecuredAdministrationAppsAppIdPermissionsRouteWithChildren
  '/_secured/administration/apps/$appId/privacy': typeof SecuredAdministrationAppsAppIdPrivacyRoute
  '/_secured/administration/apps/$appId/reports': typeof SecuredAdministrationAppsAppIdReportsRoute
  '/_secured/administration/meta-sites/$metaSiteId/permissions': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteWithChildren
  '/_secured/administration/meta-sites/$metaSiteId/settings': typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteWithChildren
  '/_secured/administration/user-groups/$groupId/members': typeof SecuredAdministrationUserGroupsGroupIdMembersRouteWithChildren
  '/_secured/administration/user-groups/$groupId/permissions': typeof SecuredAdministrationUserGroupsGroupIdPermissionsRouteWithChildren
  '/_secured/profile/api-credentials/m/create': typeof SecuredProfileApiCredentialsMCreateRoute
  '/_secured/administration/account/app/': typeof SecuredAdministrationAccountAppIndexRoute
  '/_secured/administration/account/audit-log/': typeof SecuredAdministrationAccountAuditLogIndexRoute
  '/_secured/administration/account/billing/': typeof SecuredAdministrationAccountBillingIndexRoute
  '/_secured/administration/apps/$appId/': typeof SecuredAdministrationAppsAppIdIndexRoute
  '/_secured/administration/meta-sites/$metaSiteId/': typeof SecuredAdministrationMetaSitesMetaSiteIdIndexRoute
  '/_secured/administration/user-groups/$groupId/': typeof SecuredAdministrationUserGroupsGroupIdIndexRoute
  '/_secured/administration/account/account-settings/o/edit-logo': typeof SecuredAdministrationAccountAccountSettingsOEditLogoRoute
  '/_secured/administration/account/audit-log/$page/$limit': typeof SecuredAdministrationAccountAuditLogPageLimitRoute
  '/_secured/administration/account/billing/$page/$limit': typeof SecuredAdministrationAccountBillingPageLimitRoute
  '/_secured/administration/account/domains/m/add-domain': typeof SecuredAdministrationAccountDomainsMAddDomainRoute
  '/_secured/administration/apps/$appId/installation/mobile-apps': typeof SecuredAdministrationAppsAppIdInstallationMobileAppsRoute
  '/_secured/administration/apps/$appId/installation/sites': typeof SecuredAdministrationAppsAppIdInstallationSitesRoute
  '/_secured/administration/apps/$appId/installation/': typeof SecuredAdministrationAppsAppIdInstallationIndexRoute
  '/_secured/administration/apps/$appId/permissions/': typeof SecuredAdministrationAppsAppIdPermissionsIndexRoute
  '/_secured/administration/meta-sites/$metaSiteId/permissions/': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRoute
  '/_secured/administration/meta-sites/$metaSiteId/settings/': typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRoute
  '/_secured/administration/user-groups/$groupId/members/': typeof SecuredAdministrationUserGroupsGroupIdMembersIndexRoute
  '/_secured/administration/user-groups/$groupId/permissions/': typeof SecuredAdministrationUserGroupsGroupIdPermissionsIndexRoute
  '/_secured/administration/apps/$appId/data-collection/m/edit-tracking-domains': typeof SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRoute
  '/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit': typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteWithChildren
  '/_secured/administration/meta-sites/$metaSiteId/settings/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRoute
  '/_secured/administration/user-groups/$groupId/members/$page/$limit': typeof SecuredAdministrationUserGroupsGroupIdMembersPageLimitRoute
  '/_secured/administration/user-groups/$groupId/permissions/$page/$limit': typeof SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRoute
  '/_secured/administration/apps/$appId/permissions/user-groups/$page/$limit': typeof SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRoute
  '/_secured/administration/apps/$appId/permissions/users/$page/$limit': typeof SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRoute
  '/_secured/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRoute
  '/_secured/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit': typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRoute
  '/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit': typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/administration'
    | '/info'
    | '/payment'
    | '/profile'
    | '/payment/checkout'
    | '/administration/account'
    | '/administration/apps'
    | '/administration/meta-sites'
    | '/administration/register-cmp'
    | '/administration/user-groups'
    | '/administration/users'
    | '/payment/success'
    | '/profile/api-credentials'
    | '/profile/security'
    | '/administration/'
    | '/profile/'
    | '/administration/account/account-settings'
    | '/administration/account/app'
    | '/administration/account/audit-log'
    | '/administration/account/billing'
    | '/administration/account/domains'
    | '/administration/account/subscription'
    | '/administration/apps/$appId'
    | '/administration/meta-sites/$metaSiteId'
    | '/administration/user-groups/$groupId'
    | '/administration/users/$userId'
    | '/info/no-subscription/$moduleName'
    | '/administration/account/'
    | '/administration/apps/'
    | '/administration/meta-sites/'
    | '/administration/user-groups/'
    | '/administration/users/'
    | '/administration/account/app/data-collection'
    | '/administration/account/app/privacy'
    | '/administration/apps/$appId/data-collection'
    | '/administration/apps/$appId/installation'
    | '/administration/apps/$appId/permissions'
    | '/administration/apps/$appId/privacy'
    | '/administration/apps/$appId/reports'
    | '/administration/meta-sites/$metaSiteId/permissions'
    | '/administration/meta-sites/$metaSiteId/settings'
    | '/administration/user-groups/$groupId/members'
    | '/administration/user-groups/$groupId/permissions'
    | '/profile/api-credentials/m/create'
    | '/administration/account/app/'
    | '/administration/account/audit-log/'
    | '/administration/account/billing/'
    | '/administration/apps/$appId/'
    | '/administration/meta-sites/$metaSiteId/'
    | '/administration/user-groups/$groupId/'
    | '/administration/account/account-settings/o/edit-logo'
    | '/administration/account/audit-log/$page/$limit'
    | '/administration/account/billing/$page/$limit'
    | '/administration/account/domains/m/add-domain'
    | '/administration/apps/$appId/installation/mobile-apps'
    | '/administration/apps/$appId/installation/sites'
    | '/administration/apps/$appId/installation/'
    | '/administration/apps/$appId/permissions/'
    | '/administration/meta-sites/$metaSiteId/permissions/'
    | '/administration/meta-sites/$metaSiteId/settings/'
    | '/administration/user-groups/$groupId/members/'
    | '/administration/user-groups/$groupId/permissions/'
    | '/administration/apps/$appId/data-collection/m/edit-tracking-domains'
    | '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit'
    | '/administration/meta-sites/$metaSiteId/settings/$page/$limit'
    | '/administration/user-groups/$groupId/members/$page/$limit'
    | '/administration/user-groups/$groupId/permissions/$page/$limit'
    | '/administration/apps/$appId/permissions/user-groups/$page/$limit'
    | '/administration/apps/$appId/permissions/users/$page/$limit'
    | '/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit'
    | '/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit'
    | '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/info'
    | '/payment'
    | '/payment/checkout'
    | '/'
    | '/administration/register-cmp'
    | '/payment/success'
    | '/profile/api-credentials'
    | '/profile/security'
    | '/administration'
    | '/profile'
    | '/administration/account/account-settings'
    | '/administration/account/domains'
    | '/administration/account/subscription'
    | '/administration/users/$userId'
    | '/info/no-subscription/$moduleName'
    | '/administration/account'
    | '/administration/apps'
    | '/administration/meta-sites'
    | '/administration/user-groups'
    | '/administration/users'
    | '/administration/account/app/data-collection'
    | '/administration/account/app/privacy'
    | '/administration/apps/$appId/data-collection'
    | '/administration/apps/$appId/privacy'
    | '/administration/apps/$appId/reports'
    | '/profile/api-credentials/m/create'
    | '/administration/account/app'
    | '/administration/account/audit-log'
    | '/administration/account/billing'
    | '/administration/apps/$appId'
    | '/administration/meta-sites/$metaSiteId'
    | '/administration/user-groups/$groupId'
    | '/administration/account/account-settings/o/edit-logo'
    | '/administration/account/audit-log/$page/$limit'
    | '/administration/account/billing/$page/$limit'
    | '/administration/account/domains/m/add-domain'
    | '/administration/apps/$appId/installation/mobile-apps'
    | '/administration/apps/$appId/installation/sites'
    | '/administration/apps/$appId/installation'
    | '/administration/apps/$appId/permissions'
    | '/administration/meta-sites/$metaSiteId/permissions'
    | '/administration/meta-sites/$metaSiteId/settings'
    | '/administration/user-groups/$groupId/members'
    | '/administration/user-groups/$groupId/permissions'
    | '/administration/apps/$appId/data-collection/m/edit-tracking-domains'
    | '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit'
    | '/administration/meta-sites/$metaSiteId/settings/$page/$limit'
    | '/administration/user-groups/$groupId/members/$page/$limit'
    | '/administration/user-groups/$groupId/permissions/$page/$limit'
    | '/administration/apps/$appId/permissions/user-groups/$page/$limit'
    | '/administration/apps/$appId/permissions/users/$page/$limit'
    | '/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit'
    | '/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit'
    | '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit'
  id:
    | '__root__'
    | '/_secured'
    | '/_secured/$'
    | '/_secured/administration'
    | '/_secured/info'
    | '/_secured/payment'
    | '/_secured/profile'
    | '/payment_/checkout'
    | '/_secured/'
    | '/_secured/administration/account'
    | '/_secured/administration/apps'
    | '/_secured/administration/meta-sites'
    | '/_secured/administration/register-cmp'
    | '/_secured/administration/user-groups'
    | '/_secured/administration/users'
    | '/_secured/payment_/success'
    | '/_secured/profile/api-credentials'
    | '/_secured/profile/security'
    | '/_secured/administration/'
    | '/_secured/profile/'
    | '/_secured/administration/account/account-settings'
    | '/_secured/administration/account/app'
    | '/_secured/administration/account/audit-log'
    | '/_secured/administration/account/billing'
    | '/_secured/administration/account/domains'
    | '/_secured/administration/account/subscription'
    | '/_secured/administration/apps/$appId'
    | '/_secured/administration/meta-sites/$metaSiteId'
    | '/_secured/administration/user-groups/$groupId'
    | '/_secured/administration/users/$userId'
    | '/_secured/info/no-subscription/$moduleName'
    | '/_secured/administration/account/'
    | '/_secured/administration/apps/'
    | '/_secured/administration/meta-sites/'
    | '/_secured/administration/user-groups/'
    | '/_secured/administration/users/'
    | '/_secured/administration/account/app/data-collection'
    | '/_secured/administration/account/app/privacy'
    | '/_secured/administration/apps/$appId/data-collection'
    | '/_secured/administration/apps/$appId/installation'
    | '/_secured/administration/apps/$appId/permissions'
    | '/_secured/administration/apps/$appId/privacy'
    | '/_secured/administration/apps/$appId/reports'
    | '/_secured/administration/meta-sites/$metaSiteId/permissions'
    | '/_secured/administration/meta-sites/$metaSiteId/settings'
    | '/_secured/administration/user-groups/$groupId/members'
    | '/_secured/administration/user-groups/$groupId/permissions'
    | '/_secured/profile/api-credentials/m/create'
    | '/_secured/administration/account/app/'
    | '/_secured/administration/account/audit-log/'
    | '/_secured/administration/account/billing/'
    | '/_secured/administration/apps/$appId/'
    | '/_secured/administration/meta-sites/$metaSiteId/'
    | '/_secured/administration/user-groups/$groupId/'
    | '/_secured/administration/account/account-settings/o/edit-logo'
    | '/_secured/administration/account/audit-log/$page/$limit'
    | '/_secured/administration/account/billing/$page/$limit'
    | '/_secured/administration/account/domains/m/add-domain'
    | '/_secured/administration/apps/$appId/installation/mobile-apps'
    | '/_secured/administration/apps/$appId/installation/sites'
    | '/_secured/administration/apps/$appId/installation/'
    | '/_secured/administration/apps/$appId/permissions/'
    | '/_secured/administration/meta-sites/$metaSiteId/permissions/'
    | '/_secured/administration/meta-sites/$metaSiteId/settings/'
    | '/_secured/administration/user-groups/$groupId/members/'
    | '/_secured/administration/user-groups/$groupId/permissions/'
    | '/_secured/administration/apps/$appId/data-collection/m/edit-tracking-domains'
    | '/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit'
    | '/_secured/administration/meta-sites/$metaSiteId/settings/$page/$limit'
    | '/_secured/administration/user-groups/$groupId/members/$page/$limit'
    | '/_secured/administration/user-groups/$groupId/permissions/$page/$limit'
    | '/_secured/administration/apps/$appId/permissions/user-groups/$page/$limit'
    | '/_secured/administration/apps/$appId/permissions/users/$page/$limit'
    | '/_secured/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit'
    | '/_secured/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit'
    | '/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SecuredRoute: typeof SecuredRouteWithChildren
  PaymentCheckoutRoute: typeof PaymentCheckoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_secured': {
      id: '/_secured'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SecuredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secured/': {
      id: '/_secured/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SecuredIndexRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/payment_/checkout': {
      id: '/payment_/checkout'
      path: '/payment/checkout'
      fullPath: '/payment/checkout'
      preLoaderRoute: typeof PaymentCheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secured/profile': {
      id: '/_secured/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof SecuredProfileRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/payment': {
      id: '/_secured/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof SecuredPaymentRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/info': {
      id: '/_secured/info'
      path: '/info'
      fullPath: '/info'
      preLoaderRoute: typeof SecuredInfoRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/administration': {
      id: '/_secured/administration'
      path: '/administration'
      fullPath: '/administration'
      preLoaderRoute: typeof SecuredAdministrationRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/$': {
      id: '/_secured/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SecuredSplatRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/profile/': {
      id: '/_secured/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof SecuredProfileIndexRouteImport
      parentRoute: typeof SecuredProfileRoute
    }
    '/_secured/administration/': {
      id: '/_secured/administration/'
      path: '/'
      fullPath: '/administration/'
      preLoaderRoute: typeof SecuredAdministrationIndexRouteImport
      parentRoute: typeof SecuredAdministrationRoute
    }
    '/_secured/profile/security': {
      id: '/_secured/profile/security'
      path: '/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof SecuredProfileSecurityRouteImport
      parentRoute: typeof SecuredProfileRoute
    }
    '/_secured/profile/api-credentials': {
      id: '/_secured/profile/api-credentials'
      path: '/api-credentials'
      fullPath: '/profile/api-credentials'
      preLoaderRoute: typeof SecuredProfileApiCredentialsRouteImport
      parentRoute: typeof SecuredProfileRoute
    }
    '/_secured/payment_/success': {
      id: '/_secured/payment_/success'
      path: '/payment/success'
      fullPath: '/payment/success'
      preLoaderRoute: typeof SecuredPaymentSuccessRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/administration/users': {
      id: '/_secured/administration/users'
      path: '/users'
      fullPath: '/administration/users'
      preLoaderRoute: typeof SecuredAdministrationUsersRouteImport
      parentRoute: typeof SecuredAdministrationRoute
    }
    '/_secured/administration/user-groups': {
      id: '/_secured/administration/user-groups'
      path: '/user-groups'
      fullPath: '/administration/user-groups'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsRouteImport
      parentRoute: typeof SecuredAdministrationRoute
    }
    '/_secured/administration/register-cmp': {
      id: '/_secured/administration/register-cmp'
      path: '/register-cmp'
      fullPath: '/administration/register-cmp'
      preLoaderRoute: typeof SecuredAdministrationRegisterCmpRouteImport
      parentRoute: typeof SecuredAdministrationRoute
    }
    '/_secured/administration/meta-sites': {
      id: '/_secured/administration/meta-sites'
      path: '/meta-sites'
      fullPath: '/administration/meta-sites'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesRouteImport
      parentRoute: typeof SecuredAdministrationRoute
    }
    '/_secured/administration/apps': {
      id: '/_secured/administration/apps'
      path: '/apps'
      fullPath: '/administration/apps'
      preLoaderRoute: typeof SecuredAdministrationAppsRouteImport
      parentRoute: typeof SecuredAdministrationRoute
    }
    '/_secured/administration/account': {
      id: '/_secured/administration/account'
      path: '/account'
      fullPath: '/administration/account'
      preLoaderRoute: typeof SecuredAdministrationAccountRouteImport
      parentRoute: typeof SecuredAdministrationRoute
    }
    '/_secured/administration/users/': {
      id: '/_secured/administration/users/'
      path: '/'
      fullPath: '/administration/users/'
      preLoaderRoute: typeof SecuredAdministrationUsersIndexRouteImport
      parentRoute: typeof SecuredAdministrationUsersRoute
    }
    '/_secured/administration/user-groups/': {
      id: '/_secured/administration/user-groups/'
      path: '/'
      fullPath: '/administration/user-groups/'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsIndexRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsRoute
    }
    '/_secured/administration/meta-sites/': {
      id: '/_secured/administration/meta-sites/'
      path: '/'
      fullPath: '/administration/meta-sites/'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesIndexRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesRoute
    }
    '/_secured/administration/apps/': {
      id: '/_secured/administration/apps/'
      path: '/'
      fullPath: '/administration/apps/'
      preLoaderRoute: typeof SecuredAdministrationAppsIndexRouteImport
      parentRoute: typeof SecuredAdministrationAppsRoute
    }
    '/_secured/administration/account/': {
      id: '/_secured/administration/account/'
      path: '/'
      fullPath: '/administration/account/'
      preLoaderRoute: typeof SecuredAdministrationAccountIndexRouteImport
      parentRoute: typeof SecuredAdministrationAccountRoute
    }
    '/_secured/info/no-subscription/$moduleName': {
      id: '/_secured/info/no-subscription/$moduleName'
      path: '/no-subscription/$moduleName'
      fullPath: '/info/no-subscription/$moduleName'
      preLoaderRoute: typeof SecuredInfoNoSubscriptionModuleNameRouteImport
      parentRoute: typeof SecuredInfoRoute
    }
    '/_secured/administration/users/$userId': {
      id: '/_secured/administration/users/$userId'
      path: '/$userId'
      fullPath: '/administration/users/$userId'
      preLoaderRoute: typeof SecuredAdministrationUsersUserIdRouteImport
      parentRoute: typeof SecuredAdministrationUsersRoute
    }
    '/_secured/administration/user-groups/$groupId': {
      id: '/_secured/administration/user-groups/$groupId'
      path: '/$groupId'
      fullPath: '/administration/user-groups/$groupId'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsGroupIdRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId': {
      id: '/_secured/administration/meta-sites/$metaSiteId'
      path: '/$metaSiteId'
      fullPath: '/administration/meta-sites/$metaSiteId'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesRoute
    }
    '/_secured/administration/apps/$appId': {
      id: '/_secured/administration/apps/$appId'
      path: '/$appId'
      fullPath: '/administration/apps/$appId'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdRouteImport
      parentRoute: typeof SecuredAdministrationAppsRoute
    }
    '/_secured/administration/account/subscription': {
      id: '/_secured/administration/account/subscription'
      path: '/subscription'
      fullPath: '/administration/account/subscription'
      preLoaderRoute: typeof SecuredAdministrationAccountSubscriptionRouteImport
      parentRoute: typeof SecuredAdministrationAccountRoute
    }
    '/_secured/administration/account/domains': {
      id: '/_secured/administration/account/domains'
      path: '/domains'
      fullPath: '/administration/account/domains'
      preLoaderRoute: typeof SecuredAdministrationAccountDomainsRouteImport
      parentRoute: typeof SecuredAdministrationAccountRoute
    }
    '/_secured/administration/account/billing': {
      id: '/_secured/administration/account/billing'
      path: '/billing'
      fullPath: '/administration/account/billing'
      preLoaderRoute: typeof SecuredAdministrationAccountBillingRouteImport
      parentRoute: typeof SecuredAdministrationAccountRoute
    }
    '/_secured/administration/account/audit-log': {
      id: '/_secured/administration/account/audit-log'
      path: '/audit-log'
      fullPath: '/administration/account/audit-log'
      preLoaderRoute: typeof SecuredAdministrationAccountAuditLogRouteImport
      parentRoute: typeof SecuredAdministrationAccountRoute
    }
    '/_secured/administration/account/app': {
      id: '/_secured/administration/account/app'
      path: '/app'
      fullPath: '/administration/account/app'
      preLoaderRoute: typeof SecuredAdministrationAccountAppRouteImport
      parentRoute: typeof SecuredAdministrationAccountRoute
    }
    '/_secured/administration/account/account-settings': {
      id: '/_secured/administration/account/account-settings'
      path: '/account-settings'
      fullPath: '/administration/account/account-settings'
      preLoaderRoute: typeof SecuredAdministrationAccountAccountSettingsRouteImport
      parentRoute: typeof SecuredAdministrationAccountRoute
    }
    '/_secured/administration/user-groups/$groupId/': {
      id: '/_secured/administration/user-groups/$groupId/'
      path: '/'
      fullPath: '/administration/user-groups/$groupId/'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsGroupIdIndexRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsGroupIdRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId/': {
      id: '/_secured/administration/meta-sites/$metaSiteId/'
      path: '/'
      fullPath: '/administration/meta-sites/$metaSiteId/'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdIndexRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdRoute
    }
    '/_secured/administration/apps/$appId/': {
      id: '/_secured/administration/apps/$appId/'
      path: '/'
      fullPath: '/administration/apps/$appId/'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdIndexRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdRoute
    }
    '/_secured/administration/account/billing/': {
      id: '/_secured/administration/account/billing/'
      path: '/'
      fullPath: '/administration/account/billing/'
      preLoaderRoute: typeof SecuredAdministrationAccountBillingIndexRouteImport
      parentRoute: typeof SecuredAdministrationAccountBillingRoute
    }
    '/_secured/administration/account/audit-log/': {
      id: '/_secured/administration/account/audit-log/'
      path: '/'
      fullPath: '/administration/account/audit-log/'
      preLoaderRoute: typeof SecuredAdministrationAccountAuditLogIndexRouteImport
      parentRoute: typeof SecuredAdministrationAccountAuditLogRoute
    }
    '/_secured/administration/account/app/': {
      id: '/_secured/administration/account/app/'
      path: '/'
      fullPath: '/administration/account/app/'
      preLoaderRoute: typeof SecuredAdministrationAccountAppIndexRouteImport
      parentRoute: typeof SecuredAdministrationAccountAppRoute
    }
    '/_secured/profile/api-credentials/m/create': {
      id: '/_secured/profile/api-credentials/m/create'
      path: '/m/create'
      fullPath: '/profile/api-credentials/m/create'
      preLoaderRoute: typeof SecuredProfileApiCredentialsMCreateRouteImport
      parentRoute: typeof SecuredProfileApiCredentialsRoute
    }
    '/_secured/administration/user-groups/$groupId/permissions': {
      id: '/_secured/administration/user-groups/$groupId/permissions'
      path: '/permissions'
      fullPath: '/administration/user-groups/$groupId/permissions'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsGroupIdPermissionsRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsGroupIdRoute
    }
    '/_secured/administration/user-groups/$groupId/members': {
      id: '/_secured/administration/user-groups/$groupId/members'
      path: '/members'
      fullPath: '/administration/user-groups/$groupId/members'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsGroupIdMembersRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsGroupIdRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId/settings': {
      id: '/_secured/administration/meta-sites/$metaSiteId/settings'
      path: '/settings'
      fullPath: '/administration/meta-sites/$metaSiteId/settings'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId/permissions': {
      id: '/_secured/administration/meta-sites/$metaSiteId/permissions'
      path: '/permissions'
      fullPath: '/administration/meta-sites/$metaSiteId/permissions'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdRoute
    }
    '/_secured/administration/apps/$appId/reports': {
      id: '/_secured/administration/apps/$appId/reports'
      path: '/reports'
      fullPath: '/administration/apps/$appId/reports'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdReportsRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdRoute
    }
    '/_secured/administration/apps/$appId/privacy': {
      id: '/_secured/administration/apps/$appId/privacy'
      path: '/privacy'
      fullPath: '/administration/apps/$appId/privacy'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdPrivacyRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdRoute
    }
    '/_secured/administration/apps/$appId/permissions': {
      id: '/_secured/administration/apps/$appId/permissions'
      path: '/permissions'
      fullPath: '/administration/apps/$appId/permissions'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdPermissionsRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdRoute
    }
    '/_secured/administration/apps/$appId/installation': {
      id: '/_secured/administration/apps/$appId/installation'
      path: '/installation'
      fullPath: '/administration/apps/$appId/installation'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdInstallationRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdRoute
    }
    '/_secured/administration/apps/$appId/data-collection': {
      id: '/_secured/administration/apps/$appId/data-collection'
      path: '/data-collection'
      fullPath: '/administration/apps/$appId/data-collection'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdDataCollectionRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdRoute
    }
    '/_secured/administration/account/app/privacy': {
      id: '/_secured/administration/account/app/privacy'
      path: '/privacy'
      fullPath: '/administration/account/app/privacy'
      preLoaderRoute: typeof SecuredAdministrationAccountAppPrivacyRouteImport
      parentRoute: typeof SecuredAdministrationAccountAppRoute
    }
    '/_secured/administration/account/app/data-collection': {
      id: '/_secured/administration/account/app/data-collection'
      path: '/data-collection'
      fullPath: '/administration/account/app/data-collection'
      preLoaderRoute: typeof SecuredAdministrationAccountAppDataCollectionRouteImport
      parentRoute: typeof SecuredAdministrationAccountAppRoute
    }
    '/_secured/administration/user-groups/$groupId/permissions/': {
      id: '/_secured/administration/user-groups/$groupId/permissions/'
      path: '/'
      fullPath: '/administration/user-groups/$groupId/permissions/'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsGroupIdPermissionsIndexRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsGroupIdPermissionsRoute
    }
    '/_secured/administration/user-groups/$groupId/members/': {
      id: '/_secured/administration/user-groups/$groupId/members/'
      path: '/'
      fullPath: '/administration/user-groups/$groupId/members/'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsGroupIdMembersIndexRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsGroupIdMembersRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId/settings/': {
      id: '/_secured/administration/meta-sites/$metaSiteId/settings/'
      path: '/'
      fullPath: '/administration/meta-sites/$metaSiteId/settings/'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId/permissions/': {
      id: '/_secured/administration/meta-sites/$metaSiteId/permissions/'
      path: '/'
      fullPath: '/administration/meta-sites/$metaSiteId/permissions/'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute
    }
    '/_secured/administration/apps/$appId/permissions/': {
      id: '/_secured/administration/apps/$appId/permissions/'
      path: '/'
      fullPath: '/administration/apps/$appId/permissions/'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdPermissionsIndexRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdPermissionsRoute
    }
    '/_secured/administration/apps/$appId/installation/': {
      id: '/_secured/administration/apps/$appId/installation/'
      path: '/'
      fullPath: '/administration/apps/$appId/installation/'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdInstallationIndexRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdInstallationRoute
    }
    '/_secured/administration/apps/$appId/installation/sites': {
      id: '/_secured/administration/apps/$appId/installation/sites'
      path: '/sites'
      fullPath: '/administration/apps/$appId/installation/sites'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdInstallationSitesRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdInstallationRoute
    }
    '/_secured/administration/apps/$appId/installation/mobile-apps': {
      id: '/_secured/administration/apps/$appId/installation/mobile-apps'
      path: '/mobile-apps'
      fullPath: '/administration/apps/$appId/installation/mobile-apps'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdInstallationMobileAppsRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdInstallationRoute
    }
    '/_secured/administration/account/domains/m/add-domain': {
      id: '/_secured/administration/account/domains/m/add-domain'
      path: '/m/add-domain'
      fullPath: '/administration/account/domains/m/add-domain'
      preLoaderRoute: typeof SecuredAdministrationAccountDomainsMAddDomainRouteImport
      parentRoute: typeof SecuredAdministrationAccountDomainsRoute
    }
    '/_secured/administration/account/billing/$page/$limit': {
      id: '/_secured/administration/account/billing/$page/$limit'
      path: '/$page/$limit'
      fullPath: '/administration/account/billing/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationAccountBillingPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationAccountBillingRoute
    }
    '/_secured/administration/account/audit-log/$page/$limit': {
      id: '/_secured/administration/account/audit-log/$page/$limit'
      path: '/$page/$limit'
      fullPath: '/administration/account/audit-log/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationAccountAuditLogPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationAccountAuditLogRoute
    }
    '/_secured/administration/account/account-settings/o/edit-logo': {
      id: '/_secured/administration/account/account-settings/o/edit-logo'
      path: '/o/edit-logo'
      fullPath: '/administration/account/account-settings/o/edit-logo'
      preLoaderRoute: typeof SecuredAdministrationAccountAccountSettingsOEditLogoRouteImport
      parentRoute: typeof SecuredAdministrationAccountAccountSettingsRoute
    }
    '/_secured/administration/user-groups/$groupId/permissions/$page/$limit': {
      id: '/_secured/administration/user-groups/$groupId/permissions/$page/$limit'
      path: '/$page/$limit'
      fullPath: '/administration/user-groups/$groupId/permissions/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsGroupIdPermissionsRoute
    }
    '/_secured/administration/user-groups/$groupId/members/$page/$limit': {
      id: '/_secured/administration/user-groups/$groupId/members/$page/$limit'
      path: '/$page/$limit'
      fullPath: '/administration/user-groups/$groupId/members/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationUserGroupsGroupIdMembersPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationUserGroupsGroupIdMembersRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId/settings/$page/$limit': {
      id: '/_secured/administration/meta-sites/$metaSiteId/settings/$page/$limit'
      path: '/$page/$limit'
      fullPath: '/administration/meta-sites/$metaSiteId/settings/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsRoute
    }
    '/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit': {
      id: '/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit'
      path: '/sdg/$sdgPage/$sdgLimit'
      fullPath: '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdRoute
    }
    '/_secured/administration/apps/$appId/data-collection/m/edit-tracking-domains': {
      id: '/_secured/administration/apps/$appId/data-collection/m/edit-tracking-domains'
      path: '/m/edit-tracking-domains'
      fullPath: '/administration/apps/$appId/data-collection/m/edit-tracking-domains'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdDataCollectionRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit': {
      id: '/_secured/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit'
      path: '/users/$page/$limit'
      fullPath: '/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute
    }
    '/_secured/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit': {
      id: '/_secured/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit'
      path: '/user-groups/$page/$limit'
      fullPath: '/administration/meta-sites/$metaSiteId/permissions/user-groups/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute
    }
    '/_secured/administration/apps/$appId/permissions/users/$page/$limit': {
      id: '/_secured/administration/apps/$appId/permissions/users/$page/$limit'
      path: '/users/$page/$limit'
      fullPath: '/administration/apps/$appId/permissions/users/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdPermissionsRoute
    }
    '/_secured/administration/apps/$appId/permissions/user-groups/$page/$limit': {
      id: '/_secured/administration/apps/$appId/permissions/user-groups/$page/$limit'
      path: '/user-groups/$page/$limit'
      fullPath: '/administration/apps/$appId/permissions/user-groups/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdPermissionsRoute
    }
    '/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit': {
      id: '/_secured/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit'
      path: '/o/details/$reportId/$page/$limit'
      fullPath: '/administration/apps/$appId/sdg/$sdgPage/$sdgLimit/o/details/$reportId/$page/$limit'
      preLoaderRoute: typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRouteImport
      parentRoute: typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRoute
    }
  }
}

interface SecuredAdministrationAccountAccountSettingsRouteChildren {
  SecuredAdministrationAccountAccountSettingsOEditLogoRoute: typeof SecuredAdministrationAccountAccountSettingsOEditLogoRoute
}

const SecuredAdministrationAccountAccountSettingsRouteChildren: SecuredAdministrationAccountAccountSettingsRouteChildren =
  {
    SecuredAdministrationAccountAccountSettingsOEditLogoRoute:
      SecuredAdministrationAccountAccountSettingsOEditLogoRoute,
  }

const SecuredAdministrationAccountAccountSettingsRouteWithChildren =
  SecuredAdministrationAccountAccountSettingsRoute._addFileChildren(
    SecuredAdministrationAccountAccountSettingsRouteChildren,
  )

interface SecuredAdministrationAccountAppRouteChildren {
  SecuredAdministrationAccountAppDataCollectionRoute: typeof SecuredAdministrationAccountAppDataCollectionRoute
  SecuredAdministrationAccountAppPrivacyRoute: typeof SecuredAdministrationAccountAppPrivacyRoute
  SecuredAdministrationAccountAppIndexRoute: typeof SecuredAdministrationAccountAppIndexRoute
}

const SecuredAdministrationAccountAppRouteChildren: SecuredAdministrationAccountAppRouteChildren =
  {
    SecuredAdministrationAccountAppDataCollectionRoute:
      SecuredAdministrationAccountAppDataCollectionRoute,
    SecuredAdministrationAccountAppPrivacyRoute:
      SecuredAdministrationAccountAppPrivacyRoute,
    SecuredAdministrationAccountAppIndexRoute:
      SecuredAdministrationAccountAppIndexRoute,
  }

const SecuredAdministrationAccountAppRouteWithChildren =
  SecuredAdministrationAccountAppRoute._addFileChildren(
    SecuredAdministrationAccountAppRouteChildren,
  )

interface SecuredAdministrationAccountAuditLogRouteChildren {
  SecuredAdministrationAccountAuditLogIndexRoute: typeof SecuredAdministrationAccountAuditLogIndexRoute
  SecuredAdministrationAccountAuditLogPageLimitRoute: typeof SecuredAdministrationAccountAuditLogPageLimitRoute
}

const SecuredAdministrationAccountAuditLogRouteChildren: SecuredAdministrationAccountAuditLogRouteChildren =
  {
    SecuredAdministrationAccountAuditLogIndexRoute:
      SecuredAdministrationAccountAuditLogIndexRoute,
    SecuredAdministrationAccountAuditLogPageLimitRoute:
      SecuredAdministrationAccountAuditLogPageLimitRoute,
  }

const SecuredAdministrationAccountAuditLogRouteWithChildren =
  SecuredAdministrationAccountAuditLogRoute._addFileChildren(
    SecuredAdministrationAccountAuditLogRouteChildren,
  )

interface SecuredAdministrationAccountBillingRouteChildren {
  SecuredAdministrationAccountBillingIndexRoute: typeof SecuredAdministrationAccountBillingIndexRoute
  SecuredAdministrationAccountBillingPageLimitRoute: typeof SecuredAdministrationAccountBillingPageLimitRoute
}

const SecuredAdministrationAccountBillingRouteChildren: SecuredAdministrationAccountBillingRouteChildren =
  {
    SecuredAdministrationAccountBillingIndexRoute:
      SecuredAdministrationAccountBillingIndexRoute,
    SecuredAdministrationAccountBillingPageLimitRoute:
      SecuredAdministrationAccountBillingPageLimitRoute,
  }

const SecuredAdministrationAccountBillingRouteWithChildren =
  SecuredAdministrationAccountBillingRoute._addFileChildren(
    SecuredAdministrationAccountBillingRouteChildren,
  )

interface SecuredAdministrationAccountDomainsRouteChildren {
  SecuredAdministrationAccountDomainsMAddDomainRoute: typeof SecuredAdministrationAccountDomainsMAddDomainRoute
}

const SecuredAdministrationAccountDomainsRouteChildren: SecuredAdministrationAccountDomainsRouteChildren =
  {
    SecuredAdministrationAccountDomainsMAddDomainRoute:
      SecuredAdministrationAccountDomainsMAddDomainRoute,
  }

const SecuredAdministrationAccountDomainsRouteWithChildren =
  SecuredAdministrationAccountDomainsRoute._addFileChildren(
    SecuredAdministrationAccountDomainsRouteChildren,
  )

interface SecuredAdministrationAccountRouteChildren {
  SecuredAdministrationAccountAccountSettingsRoute: typeof SecuredAdministrationAccountAccountSettingsRouteWithChildren
  SecuredAdministrationAccountAppRoute: typeof SecuredAdministrationAccountAppRouteWithChildren
  SecuredAdministrationAccountAuditLogRoute: typeof SecuredAdministrationAccountAuditLogRouteWithChildren
  SecuredAdministrationAccountBillingRoute: typeof SecuredAdministrationAccountBillingRouteWithChildren
  SecuredAdministrationAccountDomainsRoute: typeof SecuredAdministrationAccountDomainsRouteWithChildren
  SecuredAdministrationAccountSubscriptionRoute: typeof SecuredAdministrationAccountSubscriptionRoute
  SecuredAdministrationAccountIndexRoute: typeof SecuredAdministrationAccountIndexRoute
}

const SecuredAdministrationAccountRouteChildren: SecuredAdministrationAccountRouteChildren =
  {
    SecuredAdministrationAccountAccountSettingsRoute:
      SecuredAdministrationAccountAccountSettingsRouteWithChildren,
    SecuredAdministrationAccountAppRoute:
      SecuredAdministrationAccountAppRouteWithChildren,
    SecuredAdministrationAccountAuditLogRoute:
      SecuredAdministrationAccountAuditLogRouteWithChildren,
    SecuredAdministrationAccountBillingRoute:
      SecuredAdministrationAccountBillingRouteWithChildren,
    SecuredAdministrationAccountDomainsRoute:
      SecuredAdministrationAccountDomainsRouteWithChildren,
    SecuredAdministrationAccountSubscriptionRoute:
      SecuredAdministrationAccountSubscriptionRoute,
    SecuredAdministrationAccountIndexRoute:
      SecuredAdministrationAccountIndexRoute,
  }

const SecuredAdministrationAccountRouteWithChildren =
  SecuredAdministrationAccountRoute._addFileChildren(
    SecuredAdministrationAccountRouteChildren,
  )

interface SecuredAdministrationAppsAppIdDataCollectionRouteChildren {
  SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRoute: typeof SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRoute
}

const SecuredAdministrationAppsAppIdDataCollectionRouteChildren: SecuredAdministrationAppsAppIdDataCollectionRouteChildren =
  {
    SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRoute:
      SecuredAdministrationAppsAppIdDataCollectionMEditTrackingDomainsRoute,
  }

const SecuredAdministrationAppsAppIdDataCollectionRouteWithChildren =
  SecuredAdministrationAppsAppIdDataCollectionRoute._addFileChildren(
    SecuredAdministrationAppsAppIdDataCollectionRouteChildren,
  )

interface SecuredAdministrationAppsAppIdInstallationRouteChildren {
  SecuredAdministrationAppsAppIdInstallationMobileAppsRoute: typeof SecuredAdministrationAppsAppIdInstallationMobileAppsRoute
  SecuredAdministrationAppsAppIdInstallationSitesRoute: typeof SecuredAdministrationAppsAppIdInstallationSitesRoute
  SecuredAdministrationAppsAppIdInstallationIndexRoute: typeof SecuredAdministrationAppsAppIdInstallationIndexRoute
}

const SecuredAdministrationAppsAppIdInstallationRouteChildren: SecuredAdministrationAppsAppIdInstallationRouteChildren =
  {
    SecuredAdministrationAppsAppIdInstallationMobileAppsRoute:
      SecuredAdministrationAppsAppIdInstallationMobileAppsRoute,
    SecuredAdministrationAppsAppIdInstallationSitesRoute:
      SecuredAdministrationAppsAppIdInstallationSitesRoute,
    SecuredAdministrationAppsAppIdInstallationIndexRoute:
      SecuredAdministrationAppsAppIdInstallationIndexRoute,
  }

const SecuredAdministrationAppsAppIdInstallationRouteWithChildren =
  SecuredAdministrationAppsAppIdInstallationRoute._addFileChildren(
    SecuredAdministrationAppsAppIdInstallationRouteChildren,
  )

interface SecuredAdministrationAppsAppIdPermissionsRouteChildren {
  SecuredAdministrationAppsAppIdPermissionsIndexRoute: typeof SecuredAdministrationAppsAppIdPermissionsIndexRoute
  SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRoute: typeof SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRoute
  SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRoute: typeof SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRoute
}

const SecuredAdministrationAppsAppIdPermissionsRouteChildren: SecuredAdministrationAppsAppIdPermissionsRouteChildren =
  {
    SecuredAdministrationAppsAppIdPermissionsIndexRoute:
      SecuredAdministrationAppsAppIdPermissionsIndexRoute,
    SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRoute:
      SecuredAdministrationAppsAppIdPermissionsUserGroupsPageLimitRoute,
    SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRoute:
      SecuredAdministrationAppsAppIdPermissionsUsersPageLimitRoute,
  }

const SecuredAdministrationAppsAppIdPermissionsRouteWithChildren =
  SecuredAdministrationAppsAppIdPermissionsRoute._addFileChildren(
    SecuredAdministrationAppsAppIdPermissionsRouteChildren,
  )

interface SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteChildren {
  SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRoute: typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRoute
}

const SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteChildren: SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteChildren =
  {
    SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRoute:
      SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitODetailsReportIdPageLimitRoute,
  }

const SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteWithChildren =
  SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRoute._addFileChildren(
    SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteChildren,
  )

interface SecuredAdministrationAppsAppIdRouteChildren {
  SecuredAdministrationAppsAppIdDataCollectionRoute: typeof SecuredAdministrationAppsAppIdDataCollectionRouteWithChildren
  SecuredAdministrationAppsAppIdInstallationRoute: typeof SecuredAdministrationAppsAppIdInstallationRouteWithChildren
  SecuredAdministrationAppsAppIdPermissionsRoute: typeof SecuredAdministrationAppsAppIdPermissionsRouteWithChildren
  SecuredAdministrationAppsAppIdPrivacyRoute: typeof SecuredAdministrationAppsAppIdPrivacyRoute
  SecuredAdministrationAppsAppIdReportsRoute: typeof SecuredAdministrationAppsAppIdReportsRoute
  SecuredAdministrationAppsAppIdIndexRoute: typeof SecuredAdministrationAppsAppIdIndexRoute
  SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRoute: typeof SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteWithChildren
}

const SecuredAdministrationAppsAppIdRouteChildren: SecuredAdministrationAppsAppIdRouteChildren =
  {
    SecuredAdministrationAppsAppIdDataCollectionRoute:
      SecuredAdministrationAppsAppIdDataCollectionRouteWithChildren,
    SecuredAdministrationAppsAppIdInstallationRoute:
      SecuredAdministrationAppsAppIdInstallationRouteWithChildren,
    SecuredAdministrationAppsAppIdPermissionsRoute:
      SecuredAdministrationAppsAppIdPermissionsRouteWithChildren,
    SecuredAdministrationAppsAppIdPrivacyRoute:
      SecuredAdministrationAppsAppIdPrivacyRoute,
    SecuredAdministrationAppsAppIdReportsRoute:
      SecuredAdministrationAppsAppIdReportsRoute,
    SecuredAdministrationAppsAppIdIndexRoute:
      SecuredAdministrationAppsAppIdIndexRoute,
    SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRoute:
      SecuredAdministrationAppsAppIdSdgSdgPageSdgLimitRouteWithChildren,
  }

const SecuredAdministrationAppsAppIdRouteWithChildren =
  SecuredAdministrationAppsAppIdRoute._addFileChildren(
    SecuredAdministrationAppsAppIdRouteChildren,
  )

interface SecuredAdministrationAppsRouteChildren {
  SecuredAdministrationAppsAppIdRoute: typeof SecuredAdministrationAppsAppIdRouteWithChildren
  SecuredAdministrationAppsIndexRoute: typeof SecuredAdministrationAppsIndexRoute
}

const SecuredAdministrationAppsRouteChildren: SecuredAdministrationAppsRouteChildren =
  {
    SecuredAdministrationAppsAppIdRoute:
      SecuredAdministrationAppsAppIdRouteWithChildren,
    SecuredAdministrationAppsIndexRoute: SecuredAdministrationAppsIndexRoute,
  }

const SecuredAdministrationAppsRouteWithChildren =
  SecuredAdministrationAppsRoute._addFileChildren(
    SecuredAdministrationAppsRouteChildren,
  )

interface SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteChildren {
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRoute
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRoute
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRoute
}

const SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteChildren: SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteChildren =
  {
    SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRoute:
      SecuredAdministrationMetaSitesMetaSiteIdPermissionsIndexRoute,
    SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRoute:
      SecuredAdministrationMetaSitesMetaSiteIdPermissionsUserGroupsPageLimitRoute,
    SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRoute:
      SecuredAdministrationMetaSitesMetaSiteIdPermissionsUsersPageLimitRoute,
  }

const SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteWithChildren =
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute._addFileChildren(
    SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteChildren,
  )

interface SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteChildren {
  SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRoute
  SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRoute
}

const SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteChildren: SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteChildren =
  {
    SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRoute:
      SecuredAdministrationMetaSitesMetaSiteIdSettingsIndexRoute,
    SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRoute:
      SecuredAdministrationMetaSitesMetaSiteIdSettingsPageLimitRoute,
  }

const SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteWithChildren =
  SecuredAdministrationMetaSitesMetaSiteIdSettingsRoute._addFileChildren(
    SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteChildren,
  )

interface SecuredAdministrationMetaSitesMetaSiteIdRouteChildren {
  SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteWithChildren
  SecuredAdministrationMetaSitesMetaSiteIdSettingsRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteWithChildren
  SecuredAdministrationMetaSitesMetaSiteIdIndexRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdIndexRoute
}

const SecuredAdministrationMetaSitesMetaSiteIdRouteChildren: SecuredAdministrationMetaSitesMetaSiteIdRouteChildren =
  {
    SecuredAdministrationMetaSitesMetaSiteIdPermissionsRoute:
      SecuredAdministrationMetaSitesMetaSiteIdPermissionsRouteWithChildren,
    SecuredAdministrationMetaSitesMetaSiteIdSettingsRoute:
      SecuredAdministrationMetaSitesMetaSiteIdSettingsRouteWithChildren,
    SecuredAdministrationMetaSitesMetaSiteIdIndexRoute:
      SecuredAdministrationMetaSitesMetaSiteIdIndexRoute,
  }

const SecuredAdministrationMetaSitesMetaSiteIdRouteWithChildren =
  SecuredAdministrationMetaSitesMetaSiteIdRoute._addFileChildren(
    SecuredAdministrationMetaSitesMetaSiteIdRouteChildren,
  )

interface SecuredAdministrationMetaSitesRouteChildren {
  SecuredAdministrationMetaSitesMetaSiteIdRoute: typeof SecuredAdministrationMetaSitesMetaSiteIdRouteWithChildren
  SecuredAdministrationMetaSitesIndexRoute: typeof SecuredAdministrationMetaSitesIndexRoute
}

const SecuredAdministrationMetaSitesRouteChildren: SecuredAdministrationMetaSitesRouteChildren =
  {
    SecuredAdministrationMetaSitesMetaSiteIdRoute:
      SecuredAdministrationMetaSitesMetaSiteIdRouteWithChildren,
    SecuredAdministrationMetaSitesIndexRoute:
      SecuredAdministrationMetaSitesIndexRoute,
  }

const SecuredAdministrationMetaSitesRouteWithChildren =
  SecuredAdministrationMetaSitesRoute._addFileChildren(
    SecuredAdministrationMetaSitesRouteChildren,
  )

interface SecuredAdministrationUserGroupsGroupIdMembersRouteChildren {
  SecuredAdministrationUserGroupsGroupIdMembersIndexRoute: typeof SecuredAdministrationUserGroupsGroupIdMembersIndexRoute
  SecuredAdministrationUserGroupsGroupIdMembersPageLimitRoute: typeof SecuredAdministrationUserGroupsGroupIdMembersPageLimitRoute
}

const SecuredAdministrationUserGroupsGroupIdMembersRouteChildren: SecuredAdministrationUserGroupsGroupIdMembersRouteChildren =
  {
    SecuredAdministrationUserGroupsGroupIdMembersIndexRoute:
      SecuredAdministrationUserGroupsGroupIdMembersIndexRoute,
    SecuredAdministrationUserGroupsGroupIdMembersPageLimitRoute:
      SecuredAdministrationUserGroupsGroupIdMembersPageLimitRoute,
  }

const SecuredAdministrationUserGroupsGroupIdMembersRouteWithChildren =
  SecuredAdministrationUserGroupsGroupIdMembersRoute._addFileChildren(
    SecuredAdministrationUserGroupsGroupIdMembersRouteChildren,
  )

interface SecuredAdministrationUserGroupsGroupIdPermissionsRouteChildren {
  SecuredAdministrationUserGroupsGroupIdPermissionsIndexRoute: typeof SecuredAdministrationUserGroupsGroupIdPermissionsIndexRoute
  SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRoute: typeof SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRoute
}

const SecuredAdministrationUserGroupsGroupIdPermissionsRouteChildren: SecuredAdministrationUserGroupsGroupIdPermissionsRouteChildren =
  {
    SecuredAdministrationUserGroupsGroupIdPermissionsIndexRoute:
      SecuredAdministrationUserGroupsGroupIdPermissionsIndexRoute,
    SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRoute:
      SecuredAdministrationUserGroupsGroupIdPermissionsPageLimitRoute,
  }

const SecuredAdministrationUserGroupsGroupIdPermissionsRouteWithChildren =
  SecuredAdministrationUserGroupsGroupIdPermissionsRoute._addFileChildren(
    SecuredAdministrationUserGroupsGroupIdPermissionsRouteChildren,
  )

interface SecuredAdministrationUserGroupsGroupIdRouteChildren {
  SecuredAdministrationUserGroupsGroupIdMembersRoute: typeof SecuredAdministrationUserGroupsGroupIdMembersRouteWithChildren
  SecuredAdministrationUserGroupsGroupIdPermissionsRoute: typeof SecuredAdministrationUserGroupsGroupIdPermissionsRouteWithChildren
  SecuredAdministrationUserGroupsGroupIdIndexRoute: typeof SecuredAdministrationUserGroupsGroupIdIndexRoute
}

const SecuredAdministrationUserGroupsGroupIdRouteChildren: SecuredAdministrationUserGroupsGroupIdRouteChildren =
  {
    SecuredAdministrationUserGroupsGroupIdMembersRoute:
      SecuredAdministrationUserGroupsGroupIdMembersRouteWithChildren,
    SecuredAdministrationUserGroupsGroupIdPermissionsRoute:
      SecuredAdministrationUserGroupsGroupIdPermissionsRouteWithChildren,
    SecuredAdministrationUserGroupsGroupIdIndexRoute:
      SecuredAdministrationUserGroupsGroupIdIndexRoute,
  }

const SecuredAdministrationUserGroupsGroupIdRouteWithChildren =
  SecuredAdministrationUserGroupsGroupIdRoute._addFileChildren(
    SecuredAdministrationUserGroupsGroupIdRouteChildren,
  )

interface SecuredAdministrationUserGroupsRouteChildren {
  SecuredAdministrationUserGroupsGroupIdRoute: typeof SecuredAdministrationUserGroupsGroupIdRouteWithChildren
  SecuredAdministrationUserGroupsIndexRoute: typeof SecuredAdministrationUserGroupsIndexRoute
}

const SecuredAdministrationUserGroupsRouteChildren: SecuredAdministrationUserGroupsRouteChildren =
  {
    SecuredAdministrationUserGroupsGroupIdRoute:
      SecuredAdministrationUserGroupsGroupIdRouteWithChildren,
    SecuredAdministrationUserGroupsIndexRoute:
      SecuredAdministrationUserGroupsIndexRoute,
  }

const SecuredAdministrationUserGroupsRouteWithChildren =
  SecuredAdministrationUserGroupsRoute._addFileChildren(
    SecuredAdministrationUserGroupsRouteChildren,
  )

interface SecuredAdministrationUsersRouteChildren {
  SecuredAdministrationUsersUserIdRoute: typeof SecuredAdministrationUsersUserIdRoute
  SecuredAdministrationUsersIndexRoute: typeof SecuredAdministrationUsersIndexRoute
}

const SecuredAdministrationUsersRouteChildren: SecuredAdministrationUsersRouteChildren =
  {
    SecuredAdministrationUsersUserIdRoute:
      SecuredAdministrationUsersUserIdRoute,
    SecuredAdministrationUsersIndexRoute: SecuredAdministrationUsersIndexRoute,
  }

const SecuredAdministrationUsersRouteWithChildren =
  SecuredAdministrationUsersRoute._addFileChildren(
    SecuredAdministrationUsersRouteChildren,
  )

interface SecuredAdministrationRouteChildren {
  SecuredAdministrationAccountRoute: typeof SecuredAdministrationAccountRouteWithChildren
  SecuredAdministrationAppsRoute: typeof SecuredAdministrationAppsRouteWithChildren
  SecuredAdministrationMetaSitesRoute: typeof SecuredAdministrationMetaSitesRouteWithChildren
  SecuredAdministrationRegisterCmpRoute: typeof SecuredAdministrationRegisterCmpRoute
  SecuredAdministrationUserGroupsRoute: typeof SecuredAdministrationUserGroupsRouteWithChildren
  SecuredAdministrationUsersRoute: typeof SecuredAdministrationUsersRouteWithChildren
  SecuredAdministrationIndexRoute: typeof SecuredAdministrationIndexRoute
}

const SecuredAdministrationRouteChildren: SecuredAdministrationRouteChildren = {
  SecuredAdministrationAccountRoute:
    SecuredAdministrationAccountRouteWithChildren,
  SecuredAdministrationAppsRoute: SecuredAdministrationAppsRouteWithChildren,
  SecuredAdministrationMetaSitesRoute:
    SecuredAdministrationMetaSitesRouteWithChildren,
  SecuredAdministrationRegisterCmpRoute: SecuredAdministrationRegisterCmpRoute,
  SecuredAdministrationUserGroupsRoute:
    SecuredAdministrationUserGroupsRouteWithChildren,
  SecuredAdministrationUsersRoute: SecuredAdministrationUsersRouteWithChildren,
  SecuredAdministrationIndexRoute: SecuredAdministrationIndexRoute,
}

const SecuredAdministrationRouteWithChildren =
  SecuredAdministrationRoute._addFileChildren(
    SecuredAdministrationRouteChildren,
  )

interface SecuredInfoRouteChildren {
  SecuredInfoNoSubscriptionModuleNameRoute: typeof SecuredInfoNoSubscriptionModuleNameRoute
}

const SecuredInfoRouteChildren: SecuredInfoRouteChildren = {
  SecuredInfoNoSubscriptionModuleNameRoute:
    SecuredInfoNoSubscriptionModuleNameRoute,
}

const SecuredInfoRouteWithChildren = SecuredInfoRoute._addFileChildren(
  SecuredInfoRouteChildren,
)

interface SecuredProfileApiCredentialsRouteChildren {
  SecuredProfileApiCredentialsMCreateRoute: typeof SecuredProfileApiCredentialsMCreateRoute
}

const SecuredProfileApiCredentialsRouteChildren: SecuredProfileApiCredentialsRouteChildren =
  {
    SecuredProfileApiCredentialsMCreateRoute:
      SecuredProfileApiCredentialsMCreateRoute,
  }

const SecuredProfileApiCredentialsRouteWithChildren =
  SecuredProfileApiCredentialsRoute._addFileChildren(
    SecuredProfileApiCredentialsRouteChildren,
  )

interface SecuredProfileRouteChildren {
  SecuredProfileApiCredentialsRoute: typeof SecuredProfileApiCredentialsRouteWithChildren
  SecuredProfileSecurityRoute: typeof SecuredProfileSecurityRoute
  SecuredProfileIndexRoute: typeof SecuredProfileIndexRoute
}

const SecuredProfileRouteChildren: SecuredProfileRouteChildren = {
  SecuredProfileApiCredentialsRoute:
    SecuredProfileApiCredentialsRouteWithChildren,
  SecuredProfileSecurityRoute: SecuredProfileSecurityRoute,
  SecuredProfileIndexRoute: SecuredProfileIndexRoute,
}

const SecuredProfileRouteWithChildren = SecuredProfileRoute._addFileChildren(
  SecuredProfileRouteChildren,
)

interface SecuredRouteChildren {
  SecuredSplatRoute: typeof SecuredSplatRoute
  SecuredAdministrationRoute: typeof SecuredAdministrationRouteWithChildren
  SecuredInfoRoute: typeof SecuredInfoRouteWithChildren
  SecuredPaymentRoute: typeof SecuredPaymentRoute
  SecuredProfileRoute: typeof SecuredProfileRouteWithChildren
  SecuredIndexRoute: typeof SecuredIndexRoute
  SecuredPaymentSuccessRoute: typeof SecuredPaymentSuccessRoute
}

const SecuredRouteChildren: SecuredRouteChildren = {
  SecuredSplatRoute: SecuredSplatRoute,
  SecuredAdministrationRoute: SecuredAdministrationRouteWithChildren,
  SecuredInfoRoute: SecuredInfoRouteWithChildren,
  SecuredPaymentRoute: SecuredPaymentRoute,
  SecuredProfileRoute: SecuredProfileRouteWithChildren,
  SecuredIndexRoute: SecuredIndexRoute,
  SecuredPaymentSuccessRoute: SecuredPaymentSuccessRoute,
}

const SecuredRouteWithChildren =
  SecuredRoute._addFileChildren(SecuredRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SecuredRoute: SecuredRouteWithChildren,
  PaymentCheckoutRoute: PaymentCheckoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
